<script>
    import HeroCard from "./HeroCard.svelte";

    let openMenu = false;
    function toggleMenu() {
        openMenu = !openMenu;
    }
    $: menuHidden = (openMenu) ? '' : 'hidden';
</script>


<header>
    <nav class="bg-white border-gray-200 px-4 lg:px-6 py-2.5">
        <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
            <a href="/" class="flex items-center">
                <img
                    src="img/Logo_OnLabEdu_transp_232x40.png"
                    class="mr-3 h-6 sm:h-9"
                    alt="OnLabEdu Logo"
                />
                
            </a>
            <div class="flex items-center lg:order-2">
                <!--
                <a
                    href="/"
                    class="text-gray-800 hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none">Log in
                </a>
                -->
                <a href="/book">
                    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" class="fill-current text-gray-700 hover:text-sky-600">
                        <path d="M20.25 35v-2.792h11.958V7.792H20.25V5h11.958q1.125 0 1.959.833.833.834.833 1.959v24.416q0 1.125-.833 1.959-.834.833-1.959.833Zm-3.292-7.375-1.958-2 4.25-4.25H5v-2.75h14.208l-4.25-4.25 1.959-2 7.666 7.667Z"/>
                    </svg>
                </a>
                <!--
                <a href="/" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none">Get started</a>
                -->
                <button on:click|preventDefault="{toggleMenu}"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#mobileMenu"
                    class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    aria-controls="mobileMenu"
                    aria-expanded="false"
                    aria-label="Toggle main menu"
                >
                    <span class="sr-only">Open main menu</span>
                    <svg
                        class="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        ><path
                            fill-rule="evenodd"
                            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                            clip-rule="evenodd"
                        /></svg
                    >
                    <svg
                        class="hidden w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        ><path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        /></svg
                    >
            </button>
            </div>
            <div
                class="{menuHidden} justify-between items-center w-full lg:flex lg:w-auto lg:order-1"
                id="mobileMenu"
            >
                <ul
                    class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0"
                >
                    <li>
                        <a
                            href="#nav-projekt"
                            class="block py-2 pr-4 pl-3 text-gray-700 rounded bg-onlabedu-blue lg:bg-transparent lg:text-sky-600 lg:p-0"
                            aria-current="page">Projekt</a
                        >
                    </li>
                    <li>
                        <a
                            href="#nav-labore"
                            class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-sky-600 lg:p-0"
                            >Online-Labore</a
                        >
                    </li>
                    <li>
                        <a
                            href="#nav-innovationsvorhaben"
                            class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-sky-600 lg:p-0"
                            >Innovationsvorhaben</a
                        >
                    </li>
                    <li>
                        <a
                            href="#nav-laborkonzepte"
                            class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-sky-600 lg:p-0"
                            >Laborkonzepte</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</header>


<section>
    <div class="relative overflow-hidden bg-no-repeat bg-cover -z-10" style="background-position: 50%; background-image: url('img/hero_onlabedu.webp'); height: 500px;">
        <div class="absolute inset-0 w-full h-full overflow-hidden bg-fixed" style="background-color: rgba(0, 0, 0, 0.5)">
            <div class="flex justify-center items-center h-full">
                <div class="text-center text-white px-6 md:px-12">
                    <h1 class="text-5xl md:text-6xl xl:text-7xl font-bold tracking-tight mb-12">Online-Labore für<br />naturwissenschaftliche<br />Aus- und Weiterbildung</h1>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="flex flex-row justify-center items-stretch -mt-24 space-x-5">

    <HeroCard
        bgColor='bg-onlabedu-blue'
        title='Online-Labore'
        text='Wir bieten Schulen im deutschsprachigen Raum kostenlosen Zugang zu spannenden Online-Laboren aus dem MINT-Bereich.'
        buttonText='Labore ansehen...'
        buttonHref='#nav-labore'
    />

    <HeroCard
        bgColor='bg-onlabedu-green'
        title='Innovationsvorhaben'
        text='Setzen Sie mit unseren kostenlosen Online Laboren Innovationsvorhaben in der schulischen Aus- und Weiterbildung um.'
        buttonText='Weiterlesen...'
        buttonHref='#nav-innovationsvorhaben'
    />

    <HeroCard
        bgColor='bg-onlabedu-red'
        title='Neue Laborkonzepte'
        text='Sie möchten Ihr Laborkonzept als Online-Labor realisiert haben und dieses als Erstes nutzen können?'
        buttonText='Klicken Sie hier...'
        buttonHref='#nav-laborkonzepte'
    />

</div>

